import { createContext, useCallback, useMemo, useReducer, useRef } from 'react';
import RenderPixel from '../RenderPixel';

const defaultContextValue = {
  onLoad: () => {},
};
export const RenderPixelContext = createContext(defaultContextValue);

const RenderPixelProvider = ({ count, children }) => {
  const [, forceUpdate] = useReducer((x) => x + 1, 0);
  const countRef = useRef(0);

  const onLoad = useCallback(() => {
    countRef.current += 1;
    forceUpdate();
  }, []);

  const isShowRenderPixel = useMemo(
    () => count <= countRef.current,
    // eslint-disable-next-line
    [count, countRef.current]
  );

  return (
    <RenderPixelContext.Provider value={{ onLoad }}>
      {children}
      {isShowRenderPixel && <RenderPixel selectorId="main-block" />}
    </RenderPixelContext.Provider>
  );
};

export default RenderPixelProvider;
